/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Manager_Languages_CountInputs */



/**
* | output |
* | --- |
* | "{count} languages" |
*
* @param {Knp_Manager_Languages_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_languages_count = /** @type {((inputs: Knp_Manager_Languages_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Languages_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} langues`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Sprachen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} lingue`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} языки`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} idiomas`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 语言`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 言語`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} भाषाएँ`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} idiomas`)
	return /** @type {LocalizedString} */ (`${i?.count} languages`)
});